import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format, isValid, parseISO } from "date-fns";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import Text from "@ingka/text";
import "./GeneratedAtIndicator.css";
const DISPLAY_FORMAT = "dd-MM-yyyy";
const formatGeneratedAt = (isoTimestamp) => {
    const parsed = parseISO(isoTimestamp);
    return isValid(parsed) ? format(parsed, DISPLAY_FORMAT) : null;
};
export const GeneratedAtIndicator = memo(function GeneratedAtIndicator$({ generatedAt, }) {
    const { t } = useTranslation();
    if (generatedAt == null)
        return null;
    const formatted = formatGeneratedAt(generatedAt);
    if (formatted === null)
        return null;
    return (_jsxs("div", { className: "generated-at-indicator", "data-testid": "generated-at-indicator", children: [_jsx(Text, { tagName: "span", textStyle: "Body.S", className: "generated-at-indicator__label", children: `${t("forecastTab.generatedAt")}:` }), _jsx(Text, { tagName: "span", textStyle: "Body.S", className: "generated-at-indicator__value", children: formatted })] }));
});
//# sourceMappingURL=GeneratedAtIndicator.js.map